import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  results: null,
  isPanelVisible: false,
};

export const accessibilityCheckerSlice = createSlice({
  name: 'accessibilityChecker',
  initialState,
  reducers: {
    updateResults: (state, action) => {
      state.results = action.payload;
    },

    resetResults: (state, action) => {
            state.results = initialState.results;
            state.isPanelVisible = initialState.isPanelVisible;
    },

    showPanel: (state) => {
      state.isPanelVisible = true;
    },

    hidePanel: (state) => {
      state.isPanelVisible = false;
    }
  },
});

export const { updateResults, resetResults, showPanel, hidePanel } =
  accessibilityCheckerSlice.actions;

export default accessibilityCheckerSlice.reducer;
